/**
 * @file Main.layout.tsx
 * @path apps/website/src/layouts/Main.layout.tsx
 * @description Main application layout component handling UI structure.
 */

import { useEffect } from "react";
import { Outlet, ScrollRestoration, useLocation } from "react-router-dom";
import { FloatingActions } from "./floatingActions.component";
import { Footer } from "./footer.component";
import { Navigation } from "./navigation.component";

const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return (
    <>
      <ScrollRestoration />

      <Navigation />
      <main>
        <Outlet />
      </main>
      <Footer />

      <FloatingActions />
    </>
  );
};

export default Layout;
